import PropTypes from 'prop-types';
import React from 'react';
import './SponsorshipCard.scss';

export const SponsorshipCard = ({ showEditActions, onEdit, onRemove, paymentType, sponsorshipItemDescription, sponsorshipTypeImageSrc, sponsorshipTypeImageAltText, sponsorshipTypeDescription, sponsorAmount, giftRecipient, giftRecipientName }) => {

  const amountGet =() => {
    return (paymentType === 'monthly' ? `£${sponsorAmount.toFixed(2)}/month` : `£${sponsorAmount.toFixed(2)}`).replace('.00', '')
  }

  const descriptionGet = () => {
    return sponsorshipTypeDescription ? sponsorshipTypeDescription : ''
  }

  const summaryGet = () => {
    if (giftRecipient && giftRecipientName) {
      return `🎁 Sponsorship gift for ${giftRecipientName}`
    }
    else if (giftRecipient) {
      return '🎁 Sponsorship gift'
    }

    return  ''
  }

  const titleGet = () => {
    return sponsorshipItemDescription ? sponsorshipItemDescription : ''
  }

  return (
    <article className="c-sponsorship-card">
      <div className="c-sponsorship-card__image">
        <img src={sponsorshipTypeImageSrc} alt={sponsorshipTypeImageAltText} />
      </div>

      <div className="c-sponsorship-card__content">
        <div className="c-sponsorship-card__summary">{summaryGet()}</div>
        <div className="c-sponsorship-card__title"><h3>{titleGet()}</h3></div>
        <div className="c-sponsorship-card__description">{descriptionGet()}</div>

        <div className="c-sponsorship-card__amount">
          <span>{amountGet()}</span>
        </div>
       </div>

      {showEditActions &&
        <ul className="c-sponsorship-card__actions">
          <li><button onClick={onRemove}>Remove</button></li>
        </ul>
      }
    </article>
  )
}

SponsorshipCard.propTypes = {
  paymentType                 : PropTypes.string,
  sponsorshipItemDescription  : PropTypes.string,
  sponsorshipTypeImageSrc     : PropTypes.string,
  sponsorshipTypeImageAltText : PropTypes.string,
  sponsorshipTypeDescription  : PropTypes.string,
  sponsorAmount               : PropTypes.number,
  giftRecipient               : PropTypes.bool,
  giftRecipientName           : PropTypes.string,
  showEditActions             : PropTypes.bool,
  onRemove                    : PropTypes.func,
  onEdit                      : PropTypes.func
}

SponsorshipCard.defaultProps = {
  showEditActions: false,
}



